// src/components/PrivateRoute.jsx
import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { auth, rtdb } from "../config/firebase";
import { ref, get } from "firebase/database";

export default function PrivateRoute({ children }) {
  const [loading, setLoading] = useState(true);
  const [authorized, setAuthorized] = useState(false);

  useEffect(() => {
    const unsub = auth.onAuthStateChanged(async (user) => {
      if (user) {
        try {
          const snap = await get(ref(rtdb, `akun/${user.uid}/role`));
          setAuthorized(snap.exists() && snap.val() === "Admin");
        } catch (err) {
          console.error("Error checking role:", err);
          setAuthorized(false);
        }
      } else {
        setAuthorized(false);
      }
      setLoading(false);
    });

    return () => unsub();
  }, []);

  if (loading)
    return (
      <div className="flex items-center justify-center h-screen text-gray-500">
        Memeriksa akses...
      </div>
    );

  return authorized ? children : <Navigate to="/" replace />;
}
